<svelte:head>

    <title>Integrations • keyosh</title>

</svelte:head>

<script>
    import Integrations from "../../components/onboarding/integrations.svelte"
</script>


<section>

    <Integrations />

</section>


<style>

    section {
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        height: inherit;
        position: relative;
    }

    @media screen and (max-width: 1024px) {

        section {
            flex-direction: column;
            justify-content: flex-start;
            min-height: 100vh;
        }

    }

</style>
